import axios from 'axios'

const NetworkRequest = (url, options) => {
  // const axiosOptions = {}
  const axiosOptions = { isAuth: true, ...options }
  // const axiosOptions = { isAuth: true, withCredentials: true, ...options }

  axiosOptions.baseUrl = options.baseUrl || process.env.VUE_APP_BASE_API
  axiosOptions.headers = options.headers || {
    'content-type': 'application/json;charset=UTF-8'
  }
  axiosOptions.method = options.method || 'get'
  axiosOptions.timeout = options.timeout || 1 * 60 * 1000

  axiosOptions.responseType = options.responseType || ''
  if (options.data && options.method.includes('get')) {
    axiosOptions.params = options.data
  } else {
    axiosOptions.data = options.data
  }

  return new Promise((resolve, reject) => {
    axios.defaults.baseURL = process.env.VUE_APP_DOMAIN_API
    axios(url, axiosOptions).then((res) => {
      const status = res.status.toString()
      if (status.startsWith('2')) {
        const code = res.data.code
        if (code === 0) {
          resolve(res.data)
        }
      } else {
        reject()
      }
    })
  })
}

export const GET = (url = '', options = {}) => {
  return NetworkRequest(url, {
    ...options,
    method: 'get'
  })
}
